


import { mapState } from 'vuex'
export default {
data () {
return {
}
},
components: {

},
beforeCreate () {
},
mounted () {

},
beforeDestroy () {

},
methods: {

},
computed: {
...mapState({
deviceInfo: state => state.user.deviceInfo,
}),
},
}



// WEBPACK FOOTER //
// ./src/common/components/page/PageFooter.vue